import { render, staticRenderFns } from "./addBankAccount.vue?vue&type=template&id=b1e63da4&scoped=true&"
import script from "./addBankAccount.vue?vue&type=script&lang=ts&"
export * from "./addBankAccount.vue?vue&type=script&lang=ts&"
import style0 from "./addBankAccount.vue?vue&type=style&index=0&id=b1e63da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e63da4",
  null
  
)

export default component.exports